<tr [ngClass]="{'option_row--set': itemTree.extraRoles.length > 0}">
  <td easEditorBookingItemInheritableTypeHeader [inheritableType]="itemTree.extraRoles.length === 0 ? 'empty' : 'set'" i18n>
    Restricted roles with access to this bookable item
  </td>
  <td>
    <span *ngIf="itemTree.extraRoles.length === 0" class="text-muted" i18n>
      Not set
    </span>
    <span *ngIf="itemTree.extraRoles.length > 0">
      {{ extraRolesNamesAsString }}
    </span>
    <button mat-icon-button
      aria-label="Edit extra roles"
      i18n-aria-label
      (click)="onEdit()">
      <mat-icon>edit</mat-icon>
    </button>
  </td>
  <td>
    <eas-editor-booking-item-inheritable-type-badge *ngIf="itemTree.extraRoles.length > 0" [inheritableType]="'set'">
    </eas-editor-booking-item-inheritable-type-badge>
  </td>
</tr>
